/**
 * ч.1401 → ч.1431 (рішення власника): Журнал ЕДО — одна сторінка на всі режими, вхідні й вихідні
 * вкладками. У режимі «ЕДО» (зареєструвались лише щоб зберігати й підписувати електронні документи)
 * вона, поки немає жодної картки, пропонує створити картку учасника (юрособа / ФОП / фізособа + код),
 * яка підтверджується ключем КЕП (заява про приєднання до оферти). Карток може бути скільки завгодно
 * («+ картка учасника» над журналом); безкоштовно — 20 документів.
 */
import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { orgs } from '@/api/catalogs';
import { useOnboarding } from '@/hooks/useOnboarding';
import { EdoParticipantForm } from '@/pages/EdoCardPage';
import EdoJournalPage from '@/pages/EdoJournalPage';

export default function EdoJournalRoute() {
  const navigate = useNavigate();
  const { edoOnly } = useOnboarding();
  const orgsQ = useQuery({ queryKey: ['orgs'], queryFn: () => orgs.list({ limit: 200 }) });
  const noOrgs = orgsQ.isSuccess && (orgsQ.data?.items?.length ?? 0) === 0;
  if (!edoOnly) return <EdoJournalPage />;
  if (noOrgs) return <EdoParticipantForm />;
  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '0.5rem' }}>
        <button type="button" onClick={() => navigate('/edo/cards/new')}
          title="Ще одна картка учасника ЕДО — фізособа, ФОП або юрособа">+ картка учасника</button>
      </div>
      <EdoJournalPage edoMode />
    </>
  );
}
